'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useLayoutEffect, useRef } from 'react';
import { mapCtx } from './MapContext';
import cx from 'classnames';
export const MapControl = ({ position = 'TOP_LEFT', children, isMobileFullMapViewEnabled = false, isMobile = false }) => {
    const ref = useRef(null);
    const map = useContext(mapCtx);
    useLayoutEffect(() => {
        if (!map || !ref.current)
            return;
        const controlPosition = google.maps.ControlPosition[position];
        map.controls[controlPosition].push(ref.current);
    }, [map, position]);
    return (_jsx("div", { ref: ref, "data-testid": "map-control", className: cx({
            'h-100': isMobileFullMapViewEnabled && isMobile
        }), children: children }));
};
